var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-wrap"},[_c('div',{staticClass:"fx-fill fx-center-middle"},[_vm._v(" "+_vm._s(_vm.errorCode)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }